import { getStore, setStore } from '@/util/store'

import website from '@/config/website'

const tagWel = website.fistPage;
// const tagObj = {
//   label: '', //标题名称
//   value: '', //标题的路径
//   params: '', //标题的路径参数
//   query: '', //标题的参数
//   meta: {},//额外参数
//   group: [], //分组
// }


const navs = {
  state: {
    tagList: [...getStore({name: 'tagList'}) || []],
    tag: {
      path: '/wel/index',
      name: '首页'
    },
    tagWel: tagWel
  },
  actions: {},
  mutations: {
    SET_TAGLIST: (state, tagList) => {
      setStore({name: "tagList", content: tagList, type: "session"});
      state.tagList = tagList

    },
    SET_TAG: (state, tag) => {
      state.tag = tag
      let tagList = state.tagList
      tagList.forEach((item, index) => {
        if (item.fullPath == tag.fullPath) {
          state.tagList[index] = tag
        }
      })
    },
  }
}
export default navs
